import React from "react";

import "./ServiceOrderPlantingPanel.css";

function ServiceOrderFertilizationPanel({
  fertilizerName,
  onFertilizerNameChange,
  fertilizerKgHa,
  onFertilizerKgHaChange,
  t,
}) {
  return (
    <div className="service-order-planting-panel">
      <div className="service-order-planting-intro">
        <strong>{t("Recomendação de fertilização")}</strong>
        <p>
          {t(
            "No check de calibragem o operador informa os hectares do painel e quantos quilos entram a cada abastecida."
          )}
        </p>
      </div>

      <div className="service-order-planting-grid">
        <label className="service-order-planting-field service-order-planting-field--wide">
          {t("Nome do fertilizante")}
          <input
            className="form-control"
            value={fertilizerName}
            onChange={(event) => onFertilizerNameChange(event.target.value)}
            placeholder={t("Ex.: MAP, KCl, formulado 04-14-08")}
          />
        </label>

        <label className="service-order-planting-field">
          {t("Taxa-alvo (kg/ha)")}
          <input
            className="form-control"
            type="number"
            min="0"
            step="0.1"
            value={fertilizerKgHa}
            onChange={(event) => onFertilizerKgHaChange(event.target.value)}
          />
          <span>
            {t(
              "Quilos por hectare que o operador deve conferir no check de calibragem."
            )}
          </span>
        </label>
      </div>
    </div>
  );
}

export default ServiceOrderFertilizationPanel;
